export enum URLs {
    urlEnglish = '/assets/i18n/rooms-en.json',
    urlSpanish = '/assets/i18n/rooms-es.json',
  }
  